// extracted by mini-css-extract-plugin
export default {"fancyQuote":"AboutUs_fancyQuote__CEP9N"};